import { Controller } from '@hotwired/stimulus'

import { type HandlesPercentile } from '../interfaces'

const AVERAGE_PERCENTILE = 50
const METAL_LEVEL_DISTRIBUTION = {
  silver: {
    avg: 10,
    std: 6,
  },
  gold: {
    avg: 50,
    std: 22,
  },
  platinum: {
    avg: 95,
    std: 6,
  },
}

// Connects to data-controller="granular-allowances-comparison"
export default class extends Controller<HTMLParagraphElement> implements HandlesPercentile {
  updatePercentile = (percentile: number): void => {
    this.updateComparison(percentile)
  }

  updateComparison = (percentile: number): void => {
    let comparisonText: string
    let planCoverageText: string

    if ((percentile - METAL_LEVEL_DISTRIBUTION.platinum.avg) / METAL_LEVEL_DISTRIBUTION.platinum.std > 0.8) {
      planCoverageText = 'all platinum plans'
    } else if ((percentile - METAL_LEVEL_DISTRIBUTION.platinum.avg) / METAL_LEVEL_DISTRIBUTION.platinum.std > 0.4) {
      planCoverageText = 'almost all platinum plans'
    } else if ((percentile - METAL_LEVEL_DISTRIBUTION.platinum.avg) / METAL_LEVEL_DISTRIBUTION.platinum.std > -0.15) {
      planCoverageText = 'most platinum plans'
    } else if (
      ((percentile - METAL_LEVEL_DISTRIBUTION.platinum.avg) / METAL_LEVEL_DISTRIBUTION.platinum.std > -2) &&
      ((percentile - METAL_LEVEL_DISTRIBUTION.gold.avg) / METAL_LEVEL_DISTRIBUTION.gold.std > 1)
    ) {
      planCoverageText = 'all gold plans and some platinum plans'
    } else if ((percentile - METAL_LEVEL_DISTRIBUTION.gold.avg) / METAL_LEVEL_DISTRIBUTION.gold.std > 1) {
      planCoverageText = 'almost all gold plans'
    } else if ((percentile - METAL_LEVEL_DISTRIBUTION.gold.avg) / METAL_LEVEL_DISTRIBUTION.gold.std > 0) {
      planCoverageText = 'most gold plans'
    } else if (
      ((percentile - METAL_LEVEL_DISTRIBUTION.gold.avg) / METAL_LEVEL_DISTRIBUTION.gold.std > -1) &&
        ((percentile - METAL_LEVEL_DISTRIBUTION.silver.avg) / METAL_LEVEL_DISTRIBUTION.silver.std > 0.5)
    ) {
      planCoverageText = 'some gold plans'
    } else if ((percentile - METAL_LEVEL_DISTRIBUTION.silver.avg) / METAL_LEVEL_DISTRIBUTION.silver.std > 0) {
      planCoverageText = 'most silver plans'
    } else {
      planCoverageText = 'some silver plans'
    }

    const percentDifference = 100 * (percentile - AVERAGE_PERCENTILE) / AVERAGE_PERCENTILE

    if (percentDifference >= -30 && percentDifference <= 25) {
      comparisonText = String(this.element.dataset.sameBenefits).replace('{plan_coverage}', planCoverageText)
    } else if (percentDifference >= 0) {
      if (percentDifference <= 50) {
        comparisonText = String(this.element.dataset.differentBenefits).replace('{quality}', 'better').replace('{plan_coverage}', planCoverageText)
      } else if (percentDifference <= 90) {
        comparisonText = String(this.element.dataset.differentBenefits).replace('{quality}', 'significantly better').replace('{plan_coverage}', planCoverageText)
      } else {
        comparisonText = String(this.element.dataset.bestBenefits).replace('{plan_coverage}', planCoverageText)
      }
    } else { // sign < 0
      if (percentDifference >= -60) {
        comparisonText = String(this.element.dataset.differentBenefits).replace('{quality}', 'lower').replace('{plan_coverage}', planCoverageText)
      } else {
        comparisonText = String(this.element.dataset.differentBenefits).replace('{quality}', 'significantly lower').replace('{plan_coverage}', planCoverageText)
      }
    }

    this.element.innerHTML = comparisonText
  }
}
